import React from "react";

const CountdownSection = ({
  countdownParts,
  finished,
  fullDateText,
  timeText,
  fontStyleMap,
}) => {
  if (!countdownParts) {
    return null;
  }

  return (
    <section className="fw-section fw-countdown">
      <div className="fw-countdown-inner">
        <p
          className="fw-section-eyebrow"
          style={{ ...(fontStyleMap.subtitle || {}) }}
        >
          До венчавката е останато:
        </p>
        <div className="fw-countdown-grid">
          {[
            { key: "days", label: "Дена" },
            { key: "hours", label: "Сати" },
            { key: "minutes", label: "Минути" },
            { key: "seconds", label: "Секунди" },
          ].map(({ key, label }) => (
            <div className="fw-countdown-item" key={key}>
              <span
                className="fw-countdown-value"
                style={{ ...(fontStyleMap.title || {}) }}
              >
                {String(countdownParts[key]).padStart(2, "0")}
              </span>
              <span
                className="fw-countdown-label"
                style={{ ...(fontStyleMap.body || {}) }}
              >
                {label}
              </span>
            </div>
          ))}
        </div>
        {(fullDateText || timeText) && (
          <p
            className="fw-countdown-date"
            style={{ ...(fontStyleMap.body || {}) }}
          >
            {fullDateText}
            {fullDateText && timeText ? " · " : ""}
            {timeText}
          </p>
        )}
        {finished && (
          <p
            className="fw-countdown-finished"
            style={{ ...(fontStyleMap.subtitle || {}) }}
          >
            Денот е тука!
          </p>
        )}
      </div>
    </section>
  );
};

export default CountdownSection;

